import cx from 'classnames'
import React, { useContext, useState } from 'react'
import { PageContext } from '../../../context/PageContext'
import './styles.scss'

const MenuIcon = () => {
  const { handleOffcanvasMenu } = useContext(PageContext)

  const [active, setActive] = useState(false)

  const handleMenu = () => {
    handleOffcanvasMenu()
    setTimeout(
      () => {
        setActive(!active)
      },
      active ? 400 : 0
    )
  }

  return (
    <div
      className={cx({
        'menu-icon': true,
        'is-active': active
      })}
      onClick={handleMenu}
    >
      <div className="menu-icon__inner">
        <div className="menu-icon__centerBar" />
      </div>
    </div>
  )
}

export default MenuIcon
